import React from 'react';

type CalendarIconProps = React.SVGProps<SVGSVGElement>;

export const CalendarIcon: React.FC<CalendarIconProps> = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <g clipPath="url(#clip0_443_978)">
      <path
        d="M17.875 3.4375H4.125C3.7453 3.4375 3.4375 3.7453 3.4375 4.125V17.875C3.4375 18.2547 3.7453 18.5625 4.125 18.5625H17.875C18.2547 18.5625 18.5625 18.2547 18.5625 17.875V4.125C18.5625 3.7453 18.2547 3.4375 17.875 3.4375Z"
        stroke="#C5C9D6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.125 2.0625V4.8125"
        stroke="#C5C9D6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 2.0625V4.8125"
        stroke="#C5C9D6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.4375 7.5625H18.5625"
        stroke="#C5C9D6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_443_978">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

CalendarIcon.displayName = 'CalendarIcon';

export default CalendarIcon;
